// extracted by mini-css-extract-plugin
module.exports = {"left_side":"_gH","right_side":"_gI","bottom_slider":"_gJ","form_fullscreen":"_gK","footer":"_gL"};